import { Descriptions } from "@/components/v2";
import { type DescriptionsProps, Popconfirm, Space } from "antd";
import { Link } from "react-router-dom";
import { EmailTemplate } from "@rumble-it/common-lib/types/models/EmailTemplate.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card } from "@rumbledirect/ui";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

interface EmailTemplateDetailCardProps {
  template: EmailTemplate | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const EmailTemplateDetailCard = ({
  template,
  isLoading,
  deleteMutation,
}: EmailTemplateDetailCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Titel",
      children: template?.title ?? null,
    },
    {
      label: "Onderwerp",
      children: template?.subject ?? null,
    },
  ];

  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Email Template"
      extra={
        <Space>
          <Link to={`/email-templates/${template?.id}/edit`}>
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Email Template verwijderen"
            description="Weet je zeker dat je deze Email Template wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions items={items} />
    </Card>
  );
};
